import { useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import TravellersFloatingPanel from 'components/SearchV2/Components/Mobile/Panels/TravellersFloatingPanel'
import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import { getOccupancyDescription } from 'components/SearchV2/Utils/GlobalSearchV2'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import { EmptyArray } from 'lib/array/arrayUtils'

interface Props {
  isOpen: boolean
  onOpen: () => void
  onClose: () => void
  onConfirm: () => void
  hasError?: boolean
  maxGuests?: number
}

function ListingDrawerMobileHotelGuestsFields({
  isOpen,
  onOpen,
  onClose,
  onConfirm,
  hasError = false,
  maxGuests,
}: Props) {
  const intl = useIntl()
  const { occupancies = EmptyArray } = useContext(GlobalSearchStateContext)

  const applyButtonLabel = intl.formatMessage({
    id: 'ENxPPE_4gjNvtXZpYAUq',
    defaultMessage: 'Apply',
    description: 'Apply button text for search form panels in the search interface',
  })

  const guestsLabel = intl.formatMessage({
    id: 'j_s8RUuhdvQTR8vVHX5u',
    defaultMessage: 'Guests',
    description: 'Label for guests/occupancy field in the occupancy or guest picker',
  })

  const guestsDescription = useMemo(
    () => getOccupancyDescription(occupancies, intl),
    [intl, occupancies],
  )

  return (
    <>
      <TravellersFloatingPanel
        isOpen={isOpen}
        onClose={onClose}
        onConfirm={onConfirm}
        onGoBack={onClose}
        confirmText={applyButtonLabel}
        maxOccupants={maxGuests}
      />

      <SearchFormField
        label={guestsLabel}
        value={guestsDescription}
        onClick={onOpen}
        hasError={hasError}
      />
    </>
  )
}

export default ListingDrawerMobileHotelGuestsFields
